export default function AttendanceStatusCard({ employees = [], statusType }) {
  const getInitials = (name) =>
    name
      ?.split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase() || "?";

    const statusColors = {
      Present: {
        card: "border border-emerald-200 bg-emerald-50/10",
        avatarBg: "bg-emerald-100 text-emerald-800 border border-emerald-300",
        badge: "bg-emerald-100 text-emerald-700 border border-emerald-200",
      },
      Late: {
        card: "border border-amber-200 bg-amber-50/10",
        avatarBg: "bg-amber-100 text-amber-800 border border-amber-300",
        badge: "bg-amber-100 text-amber-700 border border-amber-200",
      },
      Absent: {
        card: "border border-red-200 bg-red-50/10",
        avatarBg: "bg-red-100 text-red-800 border border-red-300",
        badge: "bg-red-100 text-red-700 border border-red-200",
      },
      "On Leave": {
        card: "border border-blue-200 bg-blue-50/10",
        avatarBg: "bg-blue-200 text-blue-800 border border-blue-300",
        badge: "bg-blue-100 text-blue-700 border border-blue-200 rounded-xl",
      },
      "Filed Leave": {
        card: "border border-orange-200 bg-orange-50/10",
        avatarBg: "bg-orange-200 text-orange-800 border border-orange-300",
        badge: "bg-orange-100 text-orange-700 border border-orange-200 rounded-xl",
      },
    };

  const colors = statusColors[statusType] || statusColors.Present;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {employees.map((user, i) => {
        let badgeText = "";

        if (statusType === "Present" || statusType === "Late") {
          badgeText = user.time || "";
        } else if (statusType === "Absent") {
          badgeText = "Absent";
        } else if (statusType === "On Leave") {
          badgeText = user.leave_type || "On Leave";
        } else if (statusType === "Filed Leave") {
          badgeText = user.leave_type || "Filed Leave";
        }

        return (
          <div
            key={i}
            className={`p-4 rounded-xl border ${colors.card}`}
          >
            <div className="flex items-center justify-center gap-3">
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-full font-semibold text-[12px] ${colors.avatarBg}`}
              >
                {getInitials(user.name)}
              </div>

              <div className="flex-1">
                <p className="font-semibold text-gray-800 text-[13px] dark:text-gray-100">{user.name}</p>
                <p className="text-[11px] text-black/50 dark:text-gray-100">{user.role}</p>
              </div>

              {badgeText && (
                <div
                  className={`shrink-0 font-semibold text-[11px] rounded-xl px-2 py-0.5 ${colors.badge}`}
                >
                  {badgeText}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}